const EssayPapersRouter = [
  {
    path: '/essayPaper',
    name: 'essayPaper',
    component: () => import('../../views/EssayPapers/Index.vue'),
    meta: {
      title: '測驗去',
      layout: 'mainframe',
      haveTitle: true,
      haveBreadcrumb: true,
      keepAlive: true,
      needAuthority: true,
      isBack: false,
    },
  },
  {
    path: '/essayPapers',
    name: 'essayPapers',
    component: () => import('../../views/EssayPapers/EssayPapers.vue'),
    meta: {
      title: '申論試卷',
      layout: 'mainframe',
      haveTitle: true,
      haveBreadcrumb: true,
      keepAlive: true,
      needAuthority: true,
      isBack: false,
    },
  },
  {
    path: '/essayPapers/list/:courseId',
    name: 'essayPapersList',
    component: () => import('../../views/EssayPapers/EssayPapersList.vue'),
    meta: {
      title: '試卷列表',
      layout: 'mainframe',
      haveTitle: true,
      haveBreadcrumb: true,
      keepAlive: true,
      needAuthority: true,
      isBack: false,
      backIs: 'essayPapers',
    },
  },
  {
    path: '/essayPapers/essayExamPaper/:courseId/:paperId',
    name: 'essayExam',
    component: () => import('../../views/EssayPapers/EssayExam.vue'),
    meta: {
      title: '申論考試',
      layout: 'mainframe',
      haveTitle: true,
      haveBreadcrumb: true,
      keepAlive: false,
      needAuthority: true,
      isBack: false,
    },
  },
  {
    path: '/essayPapers/review/:courseId/:paperId',
    name: 'essayReview',
    component: () => import('../../views/EssayPapers/EssayReview.vue'),
    meta: {
      title: '申論成績檢視',
      layout: 'mainframe',
      haveTitle: true,
      haveBreadcrumb: true,
      keepAlive: false,
      needAuthority: true,
      isBack: false,
    },
  },
];

export default EssayPapersRouter;
